import React from 'react';
import {
    CLASS_PRICING_POLL,
    PRICING_POLL_DONE_LINK,
    PRICING_POLL_DONE_LINK_TEXT,
    PRICING_POLL_DONE_TEXT
} from './constants';
import { Util } from '../../../../../../util/util';
import { Button } from 'kui';
import './_PricingPollDone.scss';
import { IS_SHOW_PRICING_POLL_SESSIONSTORAGE } from '../../hocs/PricingPoll/events/onSubmit';

export const PricingPollDone = () => {
    const onClick = () => {
        const date = new Date();
        const month = date.getMonth() + 1;
        const dateParam = date.getFullYear() + '-' + (month < 10 ? '0' : '') + month;
        const url = PRICING_POLL_DONE_LINK.replace('{date}', dateParam);
        Util.popupWindow(url, 1000, 750);
        sessionStorage.setItem(IS_SHOW_PRICING_POLL_SESSIONSTORAGE, JSON.stringify(null));
    };
    return <div className={CLASS_PRICING_POLL}>
        {PRICING_POLL_DONE_TEXT}
        <Button onClick={onClick}>{PRICING_POLL_DONE_LINK_TEXT}</Button>
    </div>;
}
